import { entryList } from "../entryList";
import {
  IgrDataGrid,
  IgrDataGridModule,
  IgrNumericColumn,
  IgrTextColumn,
} from "igniteui-react-grids";
import React from "react";

IgrDataGridModule.register();

export function Entry() {
  const [data] = React.useState(entryList);
  return (
    <>
      <div
        style={{
          padding: "20px 50px 20px 50px",
          overflow: "scroll",
          WebkitOverflowScrolling: "touch",
        }}
      >
        <IgrDataGrid
          height="calc(100% + 1px)"
          width="100%"
          dataSource={data}
          autoGenerateColumns={false}
        >
          <IgrNumericColumn field="No" width="90" />
          <IgrTextColumn field="Name" headerText="名前" />
          <IgrTextColumn field="Team" headerText="チーム" />
          <IgrTextColumn field="Machine" headerText="マシン" />
        </IgrDataGrid>
      </div>
    </>
  );
}
